export default __webpack_public_path__ + "static/media/Green Arrow.4a6abaeb.jpeg";